export function getSeletcedMail(mailsList, externalId) {
  return mailsList.find(item => item.get("externalId") === externalId);
}
